import api from "services/api";
import { API_URL_VERSION } from "constants/environment";

const ENDPOINT = API_URL_VERSION + 'boats/public';

export const publicBoatService = {
    listByStatus: async (status) => {
        try {
            const response = await api.get(`${ENDPOINT}?status=${status}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "public-boat.messages.errors.list";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.patch(`${ENDPOINT}/${id}/status`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "public-boat.messages.errors.update";
        }
    },
};
